/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class Tuition 
    {
        difficulty: string;
        toolTipHeader: string = "What yearly tuition range would you like to search on?.";
        selectedInState = { type: "No Preference", cost: "" };
        selectedOutState = { type: "No Preference", cost: "" };
        selected: boolean = false;

        tuitionRanges =
            [{ type: "Less than or Equal to $5,000", cost: "Dx0,Dx5000" },
            { type: "Less than or Equal to $10,000", cost: "Dx0,Dx10000" },
            { type: "Less than or Equal to $15,000", cost: "Dx0,Dx15000" },
            { type: "Less than or Equal to $20,000", cost: "Dx0,Dx20000" },
            { type: "Less than or Equal to $25,000", cost: "Dx0,Dx25000" },
            { type: "Less than or Equal to $30,000", cost: "Dx0,Dx30000" },
            { type: "Less than or Equal to $35,000", cost: "Dx0,Dx35000" },
            { type: "Less than or Equal to $40,000", cost: "Dx0,Dx40000"},
            { type: "Less than or Equal to $45,000", cost: "Dx0,Dx45000" },
            { type: "Less than or Equal to $50,000", cost: "Dx0,Dx50000" },
            { type: "Greater than $50,000", cost: "Dx50001,Dx1000000" }];

        constructor()
        {
            
        }
        public reset( filterToRemove: string )
        {
            if ( filterToRemove.indexOf( "In-state Tuition " ) >= 0 )
                this.resetInState();
            else if ( filterToRemove.indexOf( "Out-of-state Tuition" ) >= 0 )
                this.resetOutState();
        }
        public resetInState()
        {
            this.selectedInState = this.tuitionRanges[0];
            this.checkSelected();
        }

        public resetOutState()
        {
            this.selectedOutState = this.tuitionRanges[0];
            this.checkSelected();
        }

        private checkSelected()
        {
            if ( this.selectedInState.type !== "Any Cost" || this.selectedOutState.type !== "Any Cost" )
                this.selected = true;
            else
                this.selected = false;
        }
    }
} 